type Param = string | number | string[] | {[key: string]: boolean}[] | {[key: string]: boolean};

export function classnames(...args: Param[]) {
    if (args.length === 0) {
        return '';
    } else {
        return args
            .map(item => rec(item))
            .join(' ')
            .trim();
    }
}

export const cn = classnames;

function rec(param: Param) {
    switch (true) {
        case param === null || param === undefined:
            return '';
        case typeof param === 'string':
            return param;
        case typeof param === "number":
            return param + '';
        case Array.isArray(param):
            return classnames.apply({}, param);
        case typeof param === 'object':
            return Object
                .entries(param)
                .filter(([, condition]) => !!condition)
                .map(([name]) => name)
                .join(' ');
        default:
            return '';
    }
}
